import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, fmtErr } from "@/lib/api";

export default function MembersTab() {
  const [members, setMembers] = useState([]);
  const [groups, setGroups] = useState([]);

  const load = () => {
    api.get("/coach/members").then((r) => setMembers(r.data)).catch((e) => toast.error(fmtErr(e)));
    api.get("/coach/groups").then((r) => setGroups(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const assign = async (user_id, group_id) => {
    await api.put(`/coach/members/${user_id}`, { group_id: group_id || null });
    toast.success("Group assignment updated");
    load();
  };

  return (
    <div data-testid="coach-members">
      <h2 className="font-display uppercase text-4xl mb-6">Members <span className="text-zinc-600">({members.length})</span></h2>
      <div className="border border-zinc-800 overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-[0.18em] text-zinc-500 border-b border-zinc-800">
              <th className="p-4">Member</th><th className="p-4">Age</th><th className="p-4">Latest score</th>
              <th className="p-4">Smart Pivot</th><th className="p-4">Group</th>
            </tr>
          </thead>
          <tbody>
            {members.map((m) => (
              <tr key={m.user_id} data-testid={`member-row-${m.user_id}`} className="border-b border-zinc-800/60 hover:bg-zinc-950">
                <td className="p-4">
                  <p className="font-bold text-zinc-100">{m.name}</p>
                  <p className="text-xs text-zinc-500">{m.email}</p>
                </td>
                <td className="p-4 text-zinc-400">{m.age ?? m.age_range ?? "—"}</td>
                <td className="p-4">
                  {m.latest_overall != null
                    ? <span className="font-display text-2xl text-volt">{m.latest_overall}</span>
                    : <span className="text-zinc-600 text-xs">No baseline</span>}
                </td>
                <td className="p-4">
                  {m.pivot
                    ? <span className="text-[10px] uppercase tracking-[0.12em] font-bold text-volt border border-volt/50 px-2 py-1">{m.pivot.body_part.replace("_", " ")}</span>
                    : <span className="text-zinc-600 text-xs">—</span>}
                </td>
                <td className="p-4">
                  <select data-testid={`member-group-${m.user_id}`} value={m.group_id || ""}
                    onChange={(e) => assign(m.user_id, e.target.value)}
                    className="bg-ink border border-zinc-700 px-3 py-2 text-xs text-zinc-300 focus:border-volt outline-none">
                    <option value="">No group</option>
                    {groups.map((g) => <option key={g.id} value={g.id}>{g.name}</option>)}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-zinc-600 mt-4">Members appear here after they sign in with Google and complete onboarding.</p>
    </div>
  );
}
